import React, { useState } from "react";
import { NewLoad } from "Components/NewLoad/NewLoad";
import { sidebar } from "Shared/Constants/sidebar";
import wiserLogo from "../../Assets/sidebar/wiserLogo.svg";
import styles from "./Sidebar.module.scss";
import SidebarItem from "./SidebarItem/SidebarItem";

type SidebarProps = {
  height?: number;
};

export const Sidebar: React.FC<SidebarProps> = ({ height }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.sidebar}>
      <img className={styles.sidebar__logo} src={wiserLogo} alt="logo" />
      <ul className={styles.sidebar__items}>
        {sidebar.map((el, index) => (
          <SidebarItem
            sidebarItem={el}
            index={index}
            open={open}
            setOpen={setOpen}
            key={index}
          />
        ))}
      </ul>
      <NewLoad visible={open} onCancel={() => setOpen(false)} />
    </div>
  );
};
